import {
  CreateGUFClosureRealisedPartTask,
  EditGUFClosureRealisedPartTask,
} from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGufLibraryFields } from "./guf-schema-library";

const sharedTitle = (type: FormType | undefined) =>
  `GUF Gerealiseerd deel beëindigen ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GUF gerealiseerd deel beëindigen formulier. ${getDocsLinkMarkdown(
  "GUF"
)}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  title: "Brondocumentgegevens",
  required: ["realisedInstallationId", "endTime"],
  properties: {
    ...pickGufLibraryFields([
      "realisedInstallationId",
      "installationFunction",
      "wellPos",
      "endTime",
    ]),
    realisedWells: pickGufLibraryFields(["realisedWellsClosurePart"]).realisedWellsClosurePart,
  },
};

const getGufClosureRealisedPartCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<CreateGUFClosureRealisedPartTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: ["projectNumber", "deliveryAccountableParty", "qualityRegime", "broId"],
      properties: pickGufLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
        "broId",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

const getGufClosureRealisedPartEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGUFClosureRealisedPartTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: [
        "projectNumber",
        "deliveryAccountableParty",
        "qualityRegime",
        "broId",
        "correctionReason",
      ],
      properties: {
        ...pickGufLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGufLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

export function getGufClosureRealisedPartSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGUFClosureRealisedPartTask>;
export function getGufClosureRealisedPartSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<CreateGUFClosureRealisedPartTask>;
export function getGufClosureRealisedPartSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}):
  | SchemaForFormData<EditGUFClosureRealisedPartTask>
  | SchemaForFormData<CreateGUFClosureRealisedPartTask>;
export function getGufClosureRealisedPartSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing
    ? getGufClosureRealisedPartEditSchema(type)
    : getGufClosureRealisedPartCreateSchema(type);
}
